import { SVGProps } from 'react';

const SvgSpotify = ({ ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill={'none'}
    {...props}
  >
    <title>Spotify</title>
    <g clipPath="url(#clip0_11083_41913)">
      <path
        d="M15 0.46875C6.71976 0.46875 0 6.97852 0 15C0 23.0215 6.71976 29.5312 15 29.5312C23.2802 29.5312 30 23.0215 30 15C30 6.97852 23.2802 0.46875 15 0.46875Z"
        fill="#1ED760"
      />
      <path
        d="M24.5927 13.541C24.2782 13.541 24.0847 13.4648 23.8125 13.3125C19.506 10.8223 11.8064 10.2246 6.82257 11.5723C6.60483 11.6309 6.33265 11.7246 6.04233 11.7246C5.24394 11.7246 4.63306 11.1211 4.63306 10.3418C4.63306 9.54492 5.14112 9.09375 5.68548 8.94141C7.81451 8.33789 10.1976 8.05078 12.7923 8.05078C17.2076 8.05078 21.8347 8.94141 25.2157 10.8516C25.6875 11.1152 25.996 11.4785 25.996 12.1758C25.996 12.9727 25.3306 13.541 24.5927 13.541ZM22.7177 18.0059C22.4032 18.0059 22.1915 17.8711 21.9738 17.7598C18.1935 15.5918 12.5564 14.7188 7.54233 16.0371C7.25201 16.1133 7.09475 16.1895 6.82257 16.1895C6.1754 16.1895 5.64919 15.6797 5.64919 15.0527C5.64919 14.4258 5.9637 14.0098 6.58669 13.8398C8.26814 13.3828 9.98588 13.043 12.502 13.043C16.4274 13.043 20.2197 13.9863 23.2076 15.709C23.6976 15.9902 23.8911 16.3535 23.8911 16.8633C23.8851 17.4961 23.377 18.0059 22.7177 18.0059ZM21.0907 21.8496C20.8367 21.8496 20.6794 21.7734 20.4435 21.6387C16.6693 19.4355 12.2782 19.3418 7.94152 20.2031C7.70564 20.2617 7.39717 20.3555 7.22177 20.3555C6.63507 20.3555 6.26612 19.9043 6.26612 19.4297C6.26612 18.8262 6.63507 18.5391 7.0887 18.4453C12.0423 17.3848 17.1048 17.4785 21.4234 19.9805C21.7923 20.209 22.0101 20.4141 22.0101 20.9473C22.0101 21.4805 21.5806 21.8496 21.0907 21.8496Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_11083_41913">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgSpotify;
